import React from 'react';
import { NavLink } from 'react-router-dom';
import { UilCircle } from '@iconscout/react-unicons';
import { useTranslation } from 'react-i18next';

export const getBaseMenuItems = (basePath, toggleCollapsed, topMenu) => {
  const { t } = useTranslation();
  return [
    {
      key: 'starter',
      label: (
        <NavLink onClick={toggleCollapsed} to={`${basePath}/pages/starter`}>
          {t('SMIP')} {t('Home')}
        </NavLink>
      ),
      icon: !topMenu && (
        <NavLink className="menuItem-iocn" to={`${basePath}/pages/starter`}>
          <UilCircle />
        </NavLink>
      ),
    },
  ];
};
